import { FormImageUploaderNewActionTypes, TFormImageUploaderNewAction } from './formImageUploaderNewActions';
import { IFormImageUploaderNewState } from './formImageUploaderNewContext';

export const formImageUploaderNewReducer = (
	state: IFormImageUploaderNewState,
	action: TFormImageUploaderNewAction,
): IFormImageUploaderNewState => {
	switch (action.type) {
		case FormImageUploaderNewActionTypes.SET_IMAGE_ORIENTATION:
			return {
				...state,
				imageOrientation: action.payload.imageOrientation,
			};
		case FormImageUploaderNewActionTypes.SET_LOADING:
			return {
				...state,
				isLoading: action.payload.isLoading,
			};
		case FormImageUploaderNewActionTypes.SET_UPLOADING_VIDEO:
			return {
				...state,
				isUploadingVideo: action.payload.isUploadingVideo,
			};
		case FormImageUploaderNewActionTypes.SET_CROPPED_SIZE_SRC:
			return {
				...state,
				croppedSizeSrc: action.payload.src,
			};
		case FormImageUploaderNewActionTypes.SET_COMMITTED_VIDEO_SRC:
			return {
				...state,
				committedVideoSrc: action.payload.src,
			};
		case FormImageUploaderNewActionTypes.SET_PENDING_IMAGE:
			return {
				...state,
				pendingImage: action.payload.pendingImage,
			};
		case FormImageUploaderNewActionTypes.SET_PENDING_GIF:
			return {
				...state,
				pendingGif: action.payload.pendingGif,
			};
		case FormImageUploaderNewActionTypes.SET_PENDING_VIDEO:
			return {
				...state,
				pendingVideo: action.payload.pendingVideo,
			};
		case FormImageUploaderNewActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case FormImageUploaderNewActionTypes.CHANGE_TYPE_OF_ERROR_MODAL_WINDOW:
			return {
				...state,
				typeOfErrorModalWindow: action.payload.typeOfErrorModalWindow,
			};
		case FormImageUploaderNewActionTypes.SET_LOADING_IMAGE_ERROR:
			return {
				...state,
				loadingImageError: action.payload.loadingImageError,
			};
		default:
			return state;
	}
};
